import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import CustomerView from '@/views/CustomerView'

Vue.use(Router)
/** FIXME: What is this Wesley?
 *
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
*/

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/customer',
      name: 'CustomerView',
      component: CustomerView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js